import React, { useContext } from 'react'
import { useSearchParams } from 'react-router-dom';
import { UserContext } from '../../App';

const UploadImage = () => {
  const { socket } = useContext(UserContext)
  const [searchParams, setSearchParams] = useSearchParams();

  function resizeImage(base64Str, maxWidth = 800, maxHeight = 800, callback) {
    const img = new Image();
    img.onload = () => {
      let width = img.width;
      let height = img.height;
  
      // Beregn ny størrelse
      if (width > height) {
        if (width > maxWidth) {
          height = Math.round(height *= maxWidth / width);
          width = maxWidth;
        }
      } else {
        if (height > maxHeight) {
          width = Math.round(width *= maxHeight / height);
          height = maxHeight;
        }
      }
  
      // Tegn på canvas
      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, width, height);
  
      // Gem som ny base64 (du kan også justere kvalitet på jpeg)
      const newBase64 = canvas.toDataURL('image/jpeg', 0.2); // 0.7 = 70% kvalitet
      callback(newBase64);
    };
    img.src = base64Str;
  }

  const fileUpload = (e) => {
    const { files } = e.target
    for (let i = 0; i < files.length; i++) {
      const file = files[i]
      const reader = new FileReader();
      reader.onload = () => {
        resizeImage(reader.result, 800, 800, (smallBase64) => {
          socket.emit("image", { file: smallBase64, sessionId: searchParams.get("sessionId")});
        })
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div className="z-50 bg-white fixed w-full h-lvh flex justify-center items-center">
      <div className="">
        <div className="flex flex-col w-full h-full">
          <label for="dropzone-file" className="w-full text-center sm:w-fit text-white bg-gradient-to-r from-emerald-600 to-emerald-700 px-8 py-6 bg-size-200 bg-pos-0 hover:bg-pos-100 transition-[] cursor-pointer">
            <p className="text-lg">Tilføj et billede</p>
          </label>
          <input id="dropzone-file" type="file" accept="image/apng, image/avif, image/jpeg, image/png, image/svg+xml, image/webp" multiple className="hidden" onChange={fileUpload} />
        </div>
      </div>
    </div>
  )
}

export default UploadImage